import CarouselWrapper from "../../shared/carousel-wrapper";
import PropTypes from "prop-types";
import React from "react";
import Testimonial from "./testimonial";

import { CUSTOM_IMAGE, OFFICE_AREA_IMAGE } from "../../../constants/constants";

import "./testimonials.scss";
const Testimonials = ({ entity, testimonialsTree }) => {
  const testimonials =
    testimonialsTree && testimonialsTree.length > 0 ? testimonialsTree : [];
  const options = entity.siteOptions.testimonialOptions;
  let imageUrl = null;
  if (!testimonials || testimonials.length === 0 || !options.showTestimonials) {
    return null;
  }
  if (options.background === OFFICE_AREA_IMAGE) {
    imageUrl = entity.officeAreaImageUrl;
  } else if (options.background === CUSTOM_IMAGE && options.customImage) {
    imageUrl = options.customImage;
  }
  return (
    <div
      style={
        imageUrl
          ? {
              background: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${imageUrl})`,
            }
          : {}
      }
      className={"testimonials-wrapper " + (imageUrl ? "with-image" : "")}
    >
      <div className="testimonials-inner">
        <h2 className="header-standard">Testimonials</h2>
        <div className="testimonials">
          <CarouselWrapper
            customProps={{ interval: 20000 }}
            slides={testimonials.map((testimonial, index) => (
              <Testimonial
                index={index}
                numSlides={testimonials.length}
                testimonial={testimonial}
                key={index}
                testimonialsTree={
                  testimonialsTree && testimonialsTree.length > 0 ? true : false
                }
              />
            ))}
          />
        </div>
      </div>
    </div>
  );
};

Testimonials.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/homepage/testimonials/testimonials.js